export default "__VITE_ASSET__BrbElBon__"